<template>
  <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M22 0C22.5556 0 23.0278 0.194445 23.4167 0.583333C23.8056 0.972222 24 1.44444 24 2V14C24 14.5556 23.8056 15.0278 23.4167 15.4167C23.0278 15.8056 22.5556 16 22 16H21.5C20.9444 16 20.4722 15.8056 20.0833 15.4167L16 11.3333V14C16 14.5556 15.8056 15.0278 15.4167 15.4167C15.0278 15.8056 14.5556 16 14 16H2C1.44444 16 0.972222 15.8056 0.583333 15.4167C0.194445 15.0278 0 14.5556 0 14V2C0 1.44444 0.194445 0.972222 0.583333 0.583333C0.972222 0.194445 1.44444 0 2 0H14C14.5556 0 15.0278 0.194445 15.4167 0.583333C15.8056 0.972222 16 1.44444 16 2V4.66667L20.0833 0.583333C20.4722 0.194445 20.9444 0 21.5 0H22Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Camera',
};
</script>
